import { render } from "./designReferenceFormSelectPreview.vue?vue&type=template&id=205d62b0&scoped=true"
import script from "./designReferenceFormSelectPreview.vue?vue&type=script&lang=js"
export * from "./designReferenceFormSelectPreview.vue?vue&type=script&lang=js"

import "./designReferenceFormSelectPreview.vue?vue&type=style&index=0&id=205d62b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205d62b0"]])

export default __exports__